import React from "react";
import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Form } from "react-bootstrap";

const DateRangePicker = ({ startDate, endDate, onChange }) => {
  const safeStartDate = dayjs.isDayjs(startDate) ? startDate : dayjs(startDate);
  const safeEndDate = dayjs.isDayjs(endDate) ? endDate : dayjs(endDate);

  const handleStartChange = (newStart) => {
    onChange?.({
      startDate: newStart,
      endDate: newStart && safeEndDate.isBefore(newStart) ? null : safeEndDate,
    });
  };

  const handleEndChange = (newEnd) => {
    onChange?.({ startDate: safeStartDate, endDate: newEnd });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" gap={2}>
        <Box>
          <Form.Label >Start Date</Form.Label>
          <DatePicker
            value={safeStartDate}
            onChange={handleStartChange}
            // disablePast
            // minDate={dayjs()}
            slotProps={{
              textField: { fullWidth: true },
            }}
          />
        </Box>
        <Box>
          <Form.Label >End Date</Form.Label>
          <DatePicker
            value={safeEndDate}
            onChange={handleEndChange}
            minDate={safeStartDate || dayjs()}
            disabled={!safeStartDate}
            slotProps={{
              textField: { fullWidth: true },
            }}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangePicker;
